import { render, staticRenderFns } from "./attendanceStatistics.vue?vue&type=template&id=fab83c10"
import script from "./attendanceStatistics.vue?vue&type=script&lang=js"
export * from "./attendanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./attendanceStatistics.vue?vue&type=style&index=0&id=fab83c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports